<template>
  <div class="home">
    <div class="c-top">
      <img class="bg" src="../assets/home_banner.png">
      <img class="desc_img" src="../assets/title2.jpeg">

      <div class="top-info">
        <div class="logo-img"></div>
        <div class="time"></div>
        <div class="info">
          <h3 class="title"><span class="mdd">富苑名</span>·形象设计</h3>
          <div class="des">介绍介绍这里是介绍介绍介绍这里是介绍介绍</div>
        </div>
      </div>

    </div>

    <div class="center">
      <div class="wrapper">
        <div class="list" v-for='data in list' :key="data.id">
          <router-link :to="{ name: 'about', query: { id: data.id }}" class="li">
            <div class="img">
              <img class="pic" :src="data.title_img" alt="">
            </div>
            <div class="info">
              <h3 class="name">{{ data.name }}</h3>
              <div class="detail">{{ data.desc }}  </div>
              <div class="tags">
                <div class="tag fixed" v-for="t in data.tag" :key="t">{{ t }}</div>
              </div>

              <div class="desc">
                <span class="recommend"> 店铺推荐： </span>
                历史无差评
              </div>

            </div>
          </router-link>

        </div>
      </div>
    </div>



  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {},
  data: function () {
    return {
      "list": []
    };
  },
  methods: {
    loadData: function () {
      this.axios.get("https://show.jinnrry.com/peopleList").then((response) => {
        this.list = response.data
        console.log(response.data)
      })
    }
  },
  created() {
    this.loadData();
  }
}
</script>


<style scoped>

a,a:link,a:visited,a:hover,a:active{
  text-decoration: none;
  color:inherit;
}

.recommend{
  font-size: 20px;
  color: #F5C6B9;
}

.detail{
  display: inline-flex;
  align-items: center;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  padding-top: 4px;
  padding-bottom: 8px;
  color: #242629;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.center{
  display: flex;
  justify-content: center;
}

.wrapper{
  position: relative;
  width: 80%;
}

.home{
  position: relative;
  background: #242323;
  overflow: hidden;
  z-index: 0;
}

.c-top {
  position: relative;
  z-index: 0;
}

.c-top .top-info .info {
  margin-left: 15px;
}

.c-top .top-info .info .title {
  font-size: 45px;
  line-height: 63px;
  color: #FFFFFF;
  text-align: left;
  margin: 0;
}

.c-top .top-info .info .des {
  font-size: 20px;
  line-height: 28px;
  color: #F6F7F9;
  display: flex;
  align-items: center;
}

.c-top .top-info {
  position: absolute;
  bottom: 38%;
  left: 220px;
  right: 0;
}

.bg {
  width: 100%;
  height: auto;
}

.desc_img{
  width: 55%;
  object-fit: cover;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}

.list{
  padding-top: 20px;
}

.list .li{
  display: block;
  position: relative;
  margin-bottom: 18px;
  background: #F5F5F5;
  border-radius: 9px;
  padding-right: 30px;
  height: 209px;
  z-index: 0;
  overflow: hidden;
}


.list .li:before {
  content: "";
  width: 340px;
  height: 209px;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/img_br_food.png") no-repeat;
  background-size: 100%;
  z-index: 1;
}


.list .li .pic {
  float: left;
  width: 336px;
  height: 209px;
  object-fit: cover;
  z-index: -1;
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
}

.list .info {
  text-align: left;
  position: relative;
  margin-left: 340px;
  padding: 20px 0;
}

.name{
  width: 544px;
  font-size: 18px;
  line-height: 25px;
  color: #242629;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.tags{
  width: 100%;
  height: 25px;
  overflow: hidden;
  display: inline-block;
  font-size: 0;
}

.tag{
  display: inline-block;
  padding: 2px 7px;
  margin-right: 10px;
  margin-bottom: 2px;
  font-size: 13px;
  line-height: 18px;
  color: #717376;
  border-radius: 4px;
  border: 1px solid #BDBFC2;
}

.fixed{
  position: relative;
  color: #FFFFFF;
  background: #D1A76F;
  padding: 3px 10px 3px 10px;
  border: 0;
  margin-right: 18px;
  z-index: 0;
}

.desc{
  position: relative;
  margin-top: 34px;
  padding-left: 6px;
  color: #9B6A26;
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
}

</style>